import axiosClient from './axiosClient'

const workStatusApi = {
  getAll: () => axiosClient.get('workStatuses'),
}

export default workStatusApi